import { useEffect, useState } from 'react';
import { api, LeaderEntry } from '../api/rest';
import { useT } from '../i18n';

export function Leaderboard() {
  const t = useT();
  const [entries, setEntries] = useState<LeaderEntry[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .leaderboard()
      .then(setEntries)
      .catch((err) => setError(err instanceof Error ? err.message : 'Failed to load'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="stack">
      <h1>{t('lb.title')}</h1>
      {error && <div className="banner error">{t(error)}</div>}
      {loading ? (
        <p className="muted">{t('lb.loading')}</p>
      ) : entries.length === 0 ? (
        <p className="muted">{t('lb.noGames')}</p>
      ) : (
        <div className="card">
          <ol className="leaderboard">
            {entries.map((e, i) => (
              <li key={e.nickname + i}>
                <span className="rank">{i + 1}</span>
                <span className="lname">{e.nickname}</span>
                <span className="lgames muted small">{t('lb.games', { n: e.games })}</span>
                <span className="points">{e.totalScore}</span>
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
}
